import {
  Divider,
  Drawer,
  List,
  ListItem,
} from "@material-ui/core";
import sideMenuStyles from "./SideMenuStyle";
import clsx from "clsx";

function SideMenu(props) {
  const classes = sideMenuStyles();

  const sectionOnClick = (section) => {
    props.onClose();
    props.goToSection(section);
  };

  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="right"
      classes={{
        paper: classes.drawerPaper,
      }}
      open={props.open}
      onClose={props.onClose}
    >
      <div className={classes.drawerHeader}>
       
        Video Library
      </div>
      <Divider />
      <List>
        {props.sections &&
          props.sections.map(
            (section, index) =>
              section.title && section.showInLibrary && (
                <ListItem
                  button
                  divider
                  key={index}
                  onClick={() => sectionOnClick(section)}
                  className={classes.listItem}
                >
                  <span> - </span>
                  <div
                    className={clsx([
                      classes.listItemText,
                      section.active && classes.listItemTextActive,
                    ])}
                    dangerouslySetInnerHTML={{ __html: section.question }}
                  />
                </ListItem>
              )
          )}
      </List>
    </Drawer>
  );
}

export default SideMenu;
